const { calculate } = require('./calculate')
const { calculateEstimatedMonthlyCost } = require('./calculate-estimated-monthly-cost')
const { calculateMonthlyCost } = require('./calculate-monthly-cost')
const { calculatePresentValue } = require('./calculate-present-value')
const { calculateRate } = require('./calculate-rate')
const { calculateStraightAmortization } = require('./calculate-straight-amortization')
const { calculateValues } = require('./calculate-values')
const { generatePayment } = require('./generate-payment')
const { setDisclaimer } = require('./set-disclaimer')
const { calculateTotalCost } = require('./calculate-total-cost')
const { setRefinanceDisclaimer } = require('./set-disclaimer-refinance')
const { calculateDebtRegistryCreditFacility } = require('./calculate-debt-registry-credit-facility')
const { calculateDebtRegistryRepaymentLoan } = require('./calculate-debt-registry-repayment-loan')
const { calculateDebtRegistryChargeCard } = require('./calculate-debt-registry-charge-card')

module.exports = {
  calculate,
  calculateEstimatedMonthlyCost,
  calculateMonthlyCost,
  calculatePresentValue,
  calculateRate,
  calculateStraightAmortization,
  calculateValues,
  generatePayment,
  setDisclaimer,
  calculateTotalCost,
  setRefinanceDisclaimer,
  calculateDebtRegistryCreditFacility,
  calculateDebtRegistryRepaymentLoan,
  calculateDebtRegistryChargeCard
}
